import React from 'react';
import apiRequest from '@zr/utilities/api';
import logEvent from '@zr/common/js/log_event';
import alertBubble from '@zr/common/js/alertBubble';
import { Button } from '@zr/zds/src/components/Button';
import { HeaderText } from '@zr/zds/src/components/Typography/HeaderText';

import './ExternalFeedback.less';

export type ExternalFeedbackProps = {
  listingVersionKey: string;
  placementId: string;
};

export const ExternalFeedback = ({ listingVersionKey, placementId }: ExternalFeedbackProps): JSX.Element | null => {
  const [hidden, setHidden] = React.useState(false);
  // const [showReasons, setShowReasons] = React.useState(false);

  const close = () => {
    setHidden(true);
    logEvent('button_click', { field: 'did_you_apply_close', listing_version_key: listingVersionKey });
  };

  const respondYes = async () => {
    try {
      const data = new FormData();
      data.append('listing_version_key', listingVersionKey);
      data.append('survey_display_placement_id', placementId);
      await apiRequest('/candidate/api/self-reported-applies/log', {
        method: 'POST',
        body: data,
      });

      alertBubble('We have received your feedback.', 3000);
      setHidden(true);
    } catch {
      alertBubble('There was an error saving your feedback.');
    }
  };

  const respondNo = () => {
    // setShowReasons(true);
    logEvent('button_click', { field: 'did_you_apply_no', listing_version_key: listingVersionKey });
  };

  // TODO implement the reason selection modal
  // const respondNoWithDetails = () => {
  //   let reason;
  //   setHidden(true);
  //   setShowReasons(false);
  //   logEvent('button_click', { field: 'did_you_apply_interaction', listing_version_key: listingVersionKey, reason });
  // };

  if (hidden) {
    return null;
  }

  return (
    <div className="external_feedback">
      <div className="headline">
        <HeaderText level={3}>Did you apply to this job?</HeaderText>
        <div className="close_btn_wrapper">
          <Button variant="ghost" icon="xClose" title="Close" onClick={close} />
        </div>
      </div>
      <div className="actions">
        <Button variant="secondary" grow onClick={respondYes}>
          Yes
        </Button>
        <Button variant="secondary" grow onClick={respondNo}>
          No
        </Button>
      </div>
    </div>
  );
};
